RivalIQ.module('export.models', function (models, App, Backbone, Marionette, $, _, s) {

    'use strict';

    models.ReportSchedule = Backbone.Model.extend({
        urlRoot: '/api/reportSchedule',

        trackExport: function (dashboardModel) {
            const me = this;
            const report = me.get('report');
            const tracking = dashboardModel.getScheduledExportTracking(report.get('format'));

            RivalIQ.execute('tracking:push:dynamic', tracking);
        },

        initialize: function (attrs) {
            const me = this;

            // Init child models
            const schedule = me.attributes.schedule = attrs.schedule;

            // echo model events
            me.listenTo(schedule, 'all', function (event) {
                me.trigger(`schedule:${event}`, Array.prototype.slice.call(arguments, 1));
            });

            const report = me.attributes.report = attrs.report;
            me.listenTo(report, 'all', function (event) {
                me.trigger(`report:${event}`, Array.prototype.slice.call(arguments, 1));
            });

            // NOTE report time period is always based on the schedule period
            me.listenTo(schedule, 'change:period', function (schedule, period) {
                report.set({
                    timePeriodType: period
                });
            });

            const advanced = me.attributes.advanced = attrs.advanced;
            me.listenTo(advanced, 'all', function (event) {
                me.trigger(`advanced:${event}`, Array.prototype.slice.call(arguments, 1));
            });
        },

        parse: function (attrs) {
            const emails = _.map(attrs.report.emails, function (email) {
                return {
                    email: email
                };
            });

            attrs.report = new RivalIQ.export.models.ScheduledReport(_.extend(attrs.report, {
                emails: new RivalIQ.collections.Emails(emails)
            }));

            attrs.schedule = new RivalIQ.models.Schedule(attrs.schedule);

            const advanced = {
                activeSources: attrs.active_sources,
                focusCompanyId: attrs.focus_company_id,
                scheduleOffset: attrs.schedule.get('offset')
            };

            const state = attrs.report.get('state');
            const companySetDescriptor = state.companySetDescriptor;
            if (companySetDescriptor) {
                const companySet = RivalIQ.state.companySets.get(companySetDescriptor);
                advanced.companySetDescriptor = companySet && companySet.get('companySetId');
            }

            attrs.advanced = new RivalIQ.export.models.AdvancedScheduleOptions(advanced);

            return attrs;
        },

        set: function (attrs, options) {
            const me = this;
            if (!_.isObject(attrs)) {
                throw 'String attribute setter is not supported for nested models';
            }

            const schedule = me.get('schedule');
            if (schedule) {
                schedule.set(attrs.schedule, options);
            }

            const report = me.get('report');
            if (report) {
                report.set(attrs.report, options);
            }

            const advanced = me.get('advanced');
            if (advanced) {
                advanced.set(attrs.advanced, options);
            }

            attrs = _.omit(attrs, 'schedule', 'report', 'advanced');

            return Backbone.Model.prototype.set.call(me, attrs, options);
        },

        validateSchedule: function (errors, options) {
            const me = this;
            const schedule = me.get('schedule');
            schedule.isValid(options);

            _.each(schedule.validationError, function (error) {
                errors.push([error[0] = `schedule[${error[0]}]`, error[1]]);
            });
        },

        validateReport: function (errors, options) {
            const me = this;
            const report = me.get('report');
            report.isValid(options);

            _.each(report.validationError, function (error) {
                errors.push([error[0] = `report[${error[0]}]`, error[1]]);
            });
        },

        validateAdvanced: function (errors, options) {
            const me = this;
            const advanced = me.get('advanced');
            advanced.isValid(options);

            _.each(advanced.validationError, function (error) {
                errors.push([error[0] = `advanced[${error[0]}]`, error[1]]);
            });
        },

        toJSON: function () {
            const me = this;
            const report = me.get('report');
            const schedule = me.get('schedule');
            const advanced = me.get('advanced');

            return _.extend({}, me.attributes, {
                report: report.toJSON(),
                schedule: schedule.toJSON(),
                advanced: advanced.toJSON()
            });
        },

        serialize: function () {
            const me = this;
            const report = me.get('report');
            const schedule = me.get('schedule');
            const advanced = me.get('advanced');

            return _.extend({}, me.attributes, {
                report: report.toScheduleAttributes(),
                schedule: schedule.toJSON(),
                advanced: advanced.toJSON()
            });
        },

        validate: function (attrs, options) {
            const me = this;

            const errors = [];

            me.validateSchedule(errors, options);
            me.validateReport(errors, options);
            me.validateAdvanced(errors, options);

            if (!errors.length) {
                return null;
            }

            return errors;
        },

        getIcon: function () {
            const me = this;
            // TODO normalize between export_type_id and format :(
            const format = me.get('report').get('format').toUpperCase();
            return RivalIQ.export.data.filetypes.findWhere({
                name: format
            }).get('icon');
        },

        setDuration: function (id) {
            const me = this;
            const schedule = me.get('schedule');

            if (id !== null && schedule) {
                schedule.set({
                    duration: id
                });
            }
        },

        setTypes: function (types) {
            const me = this;

            const report = me.get('report');
            report.set({
                fileTypes: types
            });
        },

        getSentence: function () {
            const me = this;

            const report = me.get('report');
            const schedule = me.get('schedule');

            return [
                'Deliver',
                '<strong>',
                report.get('title'),
                '</strong>',
                schedule.getSentence(),
                'as a',
                '<strong>',
                report.get('format').toUpperCase(),
                '</strong>',
                'to',
                '<strong>',
                s.toSentence(report.get('emails').toJSON()),
                '</strong>'
            ].join(' ');
        },

        isTimePeriodDisabled: function () {
            const me = this;
            return me.dashboardModel.isTimePeriodDisabled();
        }
    });

}, window.s);
